import { useEffect, useState } from 'react'
import { inject, observer } from 'mobx-react';
import FormMaster from '../FormMaster'
import { CommonService } from "../../../services";
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next'

let firstRender = false
const CauseOfProduct = inject("authenStore")(observer((props) => {
  const { t } = useTranslation(['cause-of-product', 'common'])
  let authenStore = props.authenStore
  let { getAccountAuth } = authenStore // STATE
  let auth = { action_user_id: getAccountAuth?.user_id, token_id: getAccountAuth?.access_token }

  const [optionStatus, setOptionStatus] = useState([])
  useEffect(() => {
    if (firstRender || !isEmpty(getAccountAuth)) {
      CommonService.getMasterData(auth, "common_status")
        .then((res: any) => {
          let common_status = res.result.common_status.map((item) => ({ label: item.status_name, value: item.status_code }))
          setOptionStatus(common_status)
        })
        .catch((err) => {
          console.log("getMasterData : ", err)
        })
    }
    else
      firstRender = true
  }, [getAccountAuth])

  return <FormMaster
    title={t('stock_adjustment_reason_info')}
    tableConfig={{
      key: "item_reason_id",
      apiPath: "item_reason/list",
      allowDelete: {
        visible: false,
        key: "group_id",
        apiPath: "prodgroup/delete"
      },
      optionDeleteFag: true,
      defaultColumn: [],
      columns: [
        {
          dataField: 'no',
          caption: t('no'),
          width: 60,
          alignment: "center",
          allowFiltering: false
        },
        {
          dataField: 'item_reason_type_name',
          caption: t('type'),
          allowFiltering: true
        },
        {
          dataField: 'item_reason_name',
          caption: t('reason'),
          allowFiltering: false
        },
        {
          dataField: 'status_name',
          caption: t('status'),
          allowFiltering: true
        },
        {
          dataField: 'updated_by',
          caption: t('edit_by'),
        }
      ],
      exportExcel: {
        fileName: t('stock_adjustment_reason_info'),
        columnConfig: [
          { label: t('no'), value: 'no' },
          { label: t('type'), value: 'item_reason_type_name' },
          { label: t('reason'), value: 'item_reason_name' },
          { label: t('status'), value: 'status_name' },
          { label: t('edit_by'), value: 'updated_by' }
        ]
      }
    }}
    formData={{
      item_reason_type: "",
      item_reason_name: "",
      status: "Y"
    }}
    modalConfig={{
      screenName: "item_reason",
      visible: true,
      title: t('stock_adjustment_reason_info'),
      required: ["item_reason_type", "item_reason_name"],
      fieldTypeNumber: [],
      paramName: "item_reason_id",
      apiPath: {
        "get": '',
        "post": 'item_reason/add',
        "put": 'item_reason/update'
      },
      elements: [
        {
          fieldName: "item_reason_type",
          label: t('type'),
          placeholder: t('type'),
          inputType: "select",
          required: true,
          defaultValue: "",
          options: [
            {
              label: "เพิ่ม",
              value: 1
            },
            {
              label: "ลด",
              value: 2
            }
          ]
        },
        {
          fieldName: "item_reason_name",
          label: t('reason'),
          placeholder: t('reason'),
          required: true,
          inputType: "text",
          isOneRow: true
        },
        {
          showSearch: false,
          fieldName: "status",
          label: t('status'),
          inputType: "select",
          required: true,
          defaultValue: "Y",
          options: optionStatus
        }
      ]
    }}
  />
}))

export default CauseOfProduct